import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/shared/auth/auth.service';
import { ConsultasSqlApi, PuestoApi, SectorApi, Turno, TurnoApi } from 'app/shared/lb-sdk';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs/observable/forkJoin';

@Component({
  selector: 'app-display-cliente-v2',
  templateUrl: './display-cliente-v2.component.html',
  styleUrls: ['./display-cliente-v2.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DisplayClienteV2Component implements OnInit {
  itemEditar = null;
  dniEditar = '';
  nombreEditar = '';
  apellidoEditar = '';
  idSectorEditar = '';
  showModalUsuario = false;
  vendedorDB = [];
  idAsignarPuesto = 0;
  sectorDB = [];
  loginOk = false;
  showModal = false;
  turnosContactologiaDB = [];
  mostrarSpinner = false;
  turnosOpticaDB = [];
  turnosAtendidosDB = [];
  isActive = true;
  @ViewChild('exampleModal') exampleModal: ElementRef;

  turnosLlamados: Array<Turno> = [];
  blink = false;
  private contadorPrueba = 0;

  minutosRecordatorio = 45;
  minutosRecordatorioAviso = 1;
  showModalRecordatorio = false;
  turnoRecordatorio: any = null;
  private recordatorioSnoozeHasta: number = null;
  private recordatorioSnoozeIdTurno: number = null;
  private avisoRecordatorioDesde: number = null;
  private cerrandoTurnoPorAviso = false;
  /** GetTurnosPendientesBack no trae fechaAtencion; la cacheamos / pedimos por id */
  private fechasAtencionPorTurno: { [idTurno: number]: Date | string } = {};
  private cargandoFechaAtencionId: number = null;

  minutosSesion = 240;
  minutosSesionAviso = 1;
  showModalSesion = false;
  private avisoSesionDesde: number = null;

  showModalNuevoTurno = false;
  dniNuevo = '';
  nombreNuevo = '';
  apellidoNuevo = '';
  idSectorNuevo: number = null;
  dniEncontradoNuevo = false;
  sectorFinalDB: Array<{ idSector: number; descripcion: string }> = [];

  private readonly nombresPrueba = [
    { nombre: 'EDUARDO JESUS', apellido: 'FERNANDEZ', dniBase: 16389910 },
    { nombre: 'MARIA EMILCE', apellido: 'LOPEZ', dniBase: 27456789 },
    { nombre: 'MATIAS', apellido: 'BRANDI', dniBase: 35678901 },
    { nombre: 'CAMILA', apellido: 'RUIZ', dniBase: 40123456 },
    { nombre: 'NICOLAS', apellido: 'GONZALEZ', dniBase: 38765432 }
  ];

  private readonly sectoresPrueba = [1, 2, 6, 7];

  constructor(
    private sectorApi: SectorApi,
    private toastr: ToastrService,
    private turnoApi: TurnoApi,
    private consultaSql: ConsultasSqlApi,
    private spinner: NgxSpinnerService,
    public authService: AuthService,
    private router: Router,
    private puestoApi: PuestoApi
  ) {
    setInterval(() => {
      this.refrescar();
    }, 4000);

    if (this.authService.userData) {
      this.loginOk = true;
    } else {
      this.router.navigateByUrl('login-cliente');
    }
  }

  actualizar() {
    this.spinner.show();
    this.turnoApi.patchAttributes(this.itemEditar.idTurno, {
      apellido: this.apellidoEditar,
      nombre: this.nombreEditar,
      dni: this.dniEditar,
      idSector: this.idSectorEditar
    }).subscribe(() => {
      this.spinner.hide();
      this.toastr.success('Datos actualizados correctamente');
      this.closeModal();
    }, () => {
      this.spinner.hide();
    });
  }

  buscarDni() {
    this.spinner.show();
    this.consultaSql.GetDatosOlp(this.dniEditar)
      .subscribe(respuesta => {
        this.spinner.hide();
        if (respuesta.success == true) {
          this.nombreEditar = respuesta.nombre;
          this.apellidoEditar = respuesta.apellido;
        } else {
          this.toastr.error('DNI no encontrado');
        }
      }, () => {
        this.spinner.hide();
      });
  }

  openModal(item) {
    this.itemEditar = item;
    this.nombreEditar = item.nombre;
    this.apellidoEditar = item.apellido;
    this.idSectorEditar = item.idSector;
    this.dniEditar = item.dni;
    this.showModal = true;
  }

  openModalAsignar(item) {
    this.itemEditar = item;
    this.showModalUsuario = true;
  }

  closeModal() {
    this.showModal = false;
  }

  closeModalAsignar() {
    this.showModalUsuario = false;
  }

  ngOnInit(): void {
    this.authService.ensureLoginAt();
    this.cargarParametroTiempoTurno();
    this.cargarParametrosSesion();
    this.cargarSectoresFinales();

    this.consultaSql.GetStoreDinamic({
      nombreStore: 'GetSectorSeleccionable',
      data: null
    }).subscribe(respuesta => {
     
      this.sectorDB = respuesta[0];
    });

    this.consultaSql.GetStoreDinamic({
      nombreStore: 'GetPuestos',
      data: { idsucursal: 1 }
    }).subscribe(respuesta => {
      this.vendedorDB = respuesta[0];
    });

    this.refrescar();
  }

  /** Sectores hoja (igual que el totem: sin hijos vía GetSectorBack). */
  private cargarSectoresFinales(): void {
    this.sectorFinalDB = [];
    this.consultaSql.GetStoreDinamic({
      nombreStore: 'GetSectorBack',
      data: { idpadre: 0 }
    }).subscribe(
      (respuesta: any) => {
        const roots = respuesta && respuesta[0] ? respuesta[0] : [];
        this.expandirSectoresHojas(roots);
      },
      () => {
        this.toastr.warning('No se pudieron cargar los sectores para nuevo turno');
      }
    );
  }

  private expandirSectoresHojas(sectores: any[]): void {
    if (!sectores || sectores.length === 0) {
      return;
    }
    sectores.forEach((sector: any) => {
      const id = sector.idsector != null ? sector.idsector : sector.idSector;
      const descripcion = sector.descripcion || sector.nombre || ('Sector ' + id);
      this.consultaSql.GetStoreDinamic({
        nombreStore: 'GetSectorBack',
        data: { idpadre: id }
      }).subscribe((respuesta: any) => {
        const hijos = respuesta && respuesta[0] ? respuesta[0] : [];
        if (!hijos || hijos.length === 0) {
          if (!this.sectorFinalDB.some(s => s.idSector == id)) {
            this.sectorFinalDB = this.sectorFinalDB
              .concat([{ idSector: id, descripcion: descripcion }])
              .sort((a, b) => (a.descripcion || '').localeCompare(b.descripcion || ''));
          }
        } else {
          this.expandirSectoresHojas(hijos);
        }
      });
    });
  }

  openModalNuevoTurno(): void {
    this.dniNuevo = '';
    this.nombreNuevo = '';
    this.apellidoNuevo = '';
    this.idSectorNuevo = null;
    this.dniEncontradoNuevo = false;
    this.showModalNuevoTurno = true;
  }

  closeModalNuevoTurno(): void {
    this.showModalNuevoTurno = false;
  }

  buscarDniNuevoTurno(): void {
    if (!this.dniNuevo || String(this.dniNuevo).trim().length < 7) {
      this.toastr.error('Debe ingresar al menos 7 dígitos de DNI');
      return;
    }
    this.spinner.show();
    this.consultaSql.GetDatosOlp(String(this.dniNuevo).trim())
      .subscribe(respuesta => {
        this.spinner.hide();
        if (respuesta.success == true) {
          this.nombreNuevo = respuesta.nombre;
          this.apellidoNuevo = respuesta.apellido;
          this.dniEncontradoNuevo = true;
        } else {
          this.dniEncontradoNuevo = false;
          this.toastr.error('DNI no encontrado');
        }
      }, () => {
        this.spinner.hide();
        this.dniEncontradoNuevo = false;
        this.toastr.error('Error al buscar DNI');
      });
  }

  guardarNuevoTurno(): void {
    if (!this.dniNuevo || String(this.dniNuevo).trim().length < 7) {
      this.toastr.error('Debe ingresar al menos 7 dígitos de DNI');
      return;
    }
    if (!this.nombreNuevo || !String(this.nombreNuevo).trim()) {
      this.toastr.error('Debe ingresar el nombre');
      return;
    }
    if (!this.apellidoNuevo || !String(this.apellidoNuevo).trim()) {
      this.toastr.error('Debe ingresar el apellido');
      return;
    }
    if (this.idSectorNuevo == null) {
      this.toastr.error('Debe seleccionar un sector');
      return;
    }
    if (!this.authService.userData || !this.authService.userData.idsucursal) {
      this.toastr.error('No hay sucursal en la sesión');
      return;
    }

    const fechaActual = new Date();
    const turno = new Turno({
      fechaTurno: new Date(fechaActual.getTime() - 3 * 60 * 60 * 1000),
      fechaAnulacion: null,
      fechaFinalizacion: null,
      fechaLlamado: null,
      fechaAtencion: null,
      idPuesto: null,
      numerador: '1',
      observaciones: '',
      nombre: String(this.nombreNuevo).trim(),
      apellido: String(this.apellidoNuevo).trim(),
      dni: String(this.dniNuevo).trim(),
      dniEncontrado: this.dniEncontradoNuevo,
      dataNosis: null,
      idEstado: 0,
      idSector: this.idSectorNuevo,
      idSucursal: this.authService.userData.idsucursal
    });

    this.spinner.show();
    this.turnoApi.create(turno).subscribe(
      () => {
        this.spinner.hide();
        this.toastr.success('Turno creado correctamente');
        this.closeModalNuevoTurno();
        this.refrescar();
      },
      () => {
        this.spinner.hide();
        this.toastr.error('Error al crear el turno');
      }
    );
  }

  private cargarParametroTiempoTurno(): void {
    this.consultaSql.GetStoreDinamic({
      nombreStore: 'GetParametro',
      data: { nombrefiltro: 'TIEMPOTURNO' }
    }).subscribe(
      (respuesta: any) => {
        const fila = respuesta && respuesta[0] && respuesta[0][0];
        const valor = fila ? parseInt(fila.valor, 10) : NaN;
        if (!isNaN(valor) && valor > 0) {
          this.minutosRecordatorio = valor;
        }
      },
      () => {
        this.minutosRecordatorio = 45;
      }
    );

    this.consultaSql.GetStoreDinamic({
      nombreStore: 'GetParametro',
      data: { nombrefiltro: 'TIEMPOTURNOAVISO' }
    }).subscribe(
      (respuesta: any) => {
        const fila = respuesta && respuesta[0] && respuesta[0][0];
        const valor = fila ? parseInt(fila.valor, 10) : NaN;
        if (!isNaN(valor) && valor > 0) {
          this.minutosRecordatorioAviso = valor;
        }
      },
      () => {
        this.minutosRecordatorioAviso = 1;
      }
    );
  }

  private cargarParametrosSesion(): void {
    this.consultaSql.GetStoreDinamic({
      nombreStore: 'GetParametro',
      data: { nombrefiltro: 'TIEMPOSESION' }
    }).subscribe(
      (respuesta: any) => {
        const fila = respuesta && respuesta[0] && respuesta[0][0];
        const valor = fila ? parseInt(fila.valor, 10) : NaN;
        if (!isNaN(valor) && valor > 0) {
          this.minutosSesion = valor;
        }
      },
      () => {
        this.minutosSesion = 240;
      }
    );

    this.consultaSql.GetStoreDinamic({
      nombreStore: 'GetParametro',
      data: { nombrefiltro: 'TIEMPOSESIONAVISO' }
    }).subscribe(
      (respuesta: any) => {
        const fila = respuesta && respuesta[0] && respuesta[0][0];
        const valor = fila ? parseInt(fila.valor, 10) : NaN;
        if (!isNaN(valor) && valor > 0) {
          this.minutosSesionAviso = valor;
        }
      },
      () => {
        this.minutosSesionAviso = 1;
      }
    );
  }

  async cambiarEstado(idestado: number, turno: Turno) {
    const fechaActual = new Date();

    if (idestado == 1) {
      this.consultaSql.GetStoreDinamic({
        nombreStore: 'ValidarLlamado',
        data: { idpuesto: this.authService.userData.id_puesto }
      }).subscribe((respuesta: any) => {
        if (respuesta[0][0].CANTIDAD == 0) {
          this.mostrarSpinner = true;
          this.turnoApi.findById(turno.idTurno)
            .subscribe((res: Turno) => {
              res.idEstado = 1;
              res.idPuesto = this.authService.userData.id_puesto;
              res.fechaAnulacion = null;
              res.fechaLlamado = new Date(fechaActual.getTime() - 3 * 60 * 60 * 1000);
              this.turnoApi.updateAttributes(turno.idTurno, res).subscribe();
              this.refrescar();
            });
        } else {
          this.toastr.error('Debe finalizar el/los turnos que tenga sin finalizar para poder llamar al próximo.');
        }
      });
    } else if (idestado == 2) {
      this.mostrarSpinner = true;
      this.turnoApi.findById(turno.idTurno)
        .subscribe((res: Turno) => {
          res.idEstado = 2;
          res.fechaAnulacion = new Date(fechaActual.getTime() - 3 * 60 * 60 * 1000);
          res.idPuesto = this.authService.userData.id_puesto;
          this.turnoApi.updateAttributes(turno.idTurno, res).subscribe();
          this.refrescar();
        }, () => {
          this.mostrarSpinner = false;
        });
    } else if (idestado == 3) {
      this.mostrarSpinner = true;
      this.turnoApi.findById(turno.idTurno)
        .subscribe((res: Turno) => {
          res.idEstado = 3;
          res.fechaFinalizacion = new Date(fechaActual.getTime() - 3 * 60 * 60 * 1000);
          res.idPuesto = this.authService.userData.id_puesto;
          this.turnoApi.updateAttributes(turno.idTurno, res).subscribe();
          delete this.fechasAtencionPorTurno[turno.idTurno];
          if (this.recordatorioSnoozeIdTurno === turno.idTurno) {
            this.cerrarModalRecordatorio(true);
          }
          this.refrescar();
        }, () => {
          this.mostrarSpinner = false;
        });
    } else if (idestado == 4) {
      this.mostrarSpinner = true;
      this.turnoApi.findById(turno.idTurno)
        .subscribe((res: Turno) => {
          res.idEstado = 4;
          const fechaAtencion = new Date(fechaActual.getTime() - 3 * 60 * 60 * 1000);
          res.fechaAtencion = fechaAtencion;
          res.idPuesto = this.authService.userData.id_puesto;
          this.fechasAtencionPorTurno[turno.idTurno] = fechaAtencion;
          this.turnoApi.updateAttributes(turno.idTurno, res).subscribe();
          this.refrescar();
        }, () => {
          this.mostrarSpinner = false;
        });
    } else if (idestado == 0) {
      this.mostrarSpinner = true;
      this.turnoApi.findById(turno.idTurno)
        .subscribe((res: Turno) => {
          res.fechaAtencion = null;
          res.idPuesto == null;
          res.idEstado = 0;
          delete this.fechasAtencionPorTurno[turno.idTurno];
          this.turnoApi.updateAttributes(turno.idTurno, res).subscribe();
          this.refrescar();
        }, () => {
          this.mostrarSpinner = false;
        });
    }
  }

  asignarPendiente() {
    this.spinner.show();
    this.consultaSql.GetStoreDinamic({
      nombreStore: 'GetPendienteAsignado',
      data: {
        idTurno: this.itemEditar.idTurno,
        idPuestoAsignado: this.idAsignarPuesto
      }
    }).subscribe(() => {
      this.spinner.hide();
      this.toastr.success('Datos actualizados correctamente');
      this.closeModalAsignar();
      this.refrescar();
    }, () => {
      this.spinner.hide();
    });
  }

  cerrarSesion() {
    this.showModalSesion = false;
    this.avisoSesionDesde = null;
    this.authService.logout();
    this.router.navigateByUrl('login-cliente');
  }

  continuarSesion(): void {
    this.authService.markLoginAt();
    this.showModalSesion = false;
    this.avisoSesionDesde = null;
    this.toastr.success('Sesión extendida');
  }

  private cerrarSesionPorExpiracion(motivo: string): void {
    this.showModalSesion = false;
    this.avisoSesionDesde = null;
    this.authService.logout();
    this.toastr.warning(motivo);
    this.router.navigateByUrl('login-cliente');
  }

  private verificarSesion(): boolean {
    if (!this.authService.isLoggedIn()) {
      this.router.navigateByUrl('login-cliente');
      return false;
    }

    this.authService.ensureLoginAt();
    const loginAt = this.authService.getLoginAt();
    if (loginAt == null) {
      return true;
    }

    const minutosDesdeLogin = (Date.now() - loginAt) / 60000;

    if (this.showModalSesion && this.avisoSesionDesde != null) {
      const minutosAviso = (Date.now() - this.avisoSesionDesde) / 60000;
      if (minutosAviso >= this.minutosSesionAviso) {
        this.cerrarSesionPorExpiracion(
          'Sesión cerrada automáticamente por falta de respuesta'
        );
        return false;
      }
      return true;
    }

    if (minutosDesdeLogin >= this.minutosSesion) {
      this.showModalSesion = true;
      this.avisoSesionDesde = Date.now();
    }

    return true;
  }

  verReporte() {
    this.router.navigateByUrl('grilla-turnos');
  }

  verParametros() {
    this.router.navigateByUrl('abm-parametros');
  }

  generarTurnosPrueba(): void {
    const cantidad = 5;
    const solicitudes = [];

    for (let i = 0; i < cantidad; i++) {
      solicitudes.push(this.turnoApi.create(this.armarTurnoPrueba(i)));
    }

    this.spinner.show();
    forkJoin(solicitudes).subscribe(
      () => {
        this.contadorPrueba++;
        this.spinner.hide();
        this.toastr.success('Se generaron 5 turnos de prueba');
        this.refrescar();
      },
      () => {
        this.spinner.hide();
        this.toastr.error('Error al generar turnos de prueba');
      }
    );
  }

  private armarTurnoPrueba(indice: number): Turno {
    const persona = this.nombresPrueba[indice % this.nombresPrueba.length];
    const fechaActual = new Date();
    const dni = String(persona.dniBase + this.contadorPrueba * 100 + indice);

    return new Turno({
      fechaTurno: new Date(fechaActual.getTime() - 3 * 60 * 60 * 1000),
      fechaAnulacion: null,
      fechaFinalizacion: null,
      fechaLlamado: null,
      fechaAtencion: null,
      idPuesto: null,
      numerador: String(Math.floor(Math.random() * 9000) + 1000),
      observaciones: '',
      nombre: persona.nombre,
      apellido: persona.apellido,
      dni: dni,
      dniEncontrado: true,
      dataNosis: null,
      idEstado: 0,
      idSector: this.sectoresPrueba[indice % this.sectoresPrueba.length],
      idSucursal: this.authService.userData.idsucursal
    });
  }

  refrescar() {
    if (!this.verificarSesion()) {
      return;
    }

    if (this.mostrarSpinner == true) {
      this.spinner.show();
      this.mostrarSpinner = false;
    }

    if (!this.authService.userData) {
      return;
    }

    const observables = [
      this.consultaSql.GetStoreDinamic({
        nombreStore: 'GetTurnosPendientesBack',
        data: { IDESTADOFILTRO: '0', IDSECTORFILTRO: '1', IDSUCURSALFILTRO: this.authService.userData.idsucursal }
      }),
      this.consultaSql.GetStoreDinamic({
        nombreStore: 'GetTurnosPendientesBack',
        data: { IDESTADOFILTRO: '0', IDSECTORFILTRO: '2', IDSUCURSALFILTRO: this.authService.userData.idsucursal }
      }),
      this.consultaSql.GetStoreDinamic({
        nombreStore: 'GetTurnosAtendidosBack',//'GetTurnosAtendidos',
        data: { IDESTADOFILTRO: '3', IDSUCURSALFILTRO: this.authService.userData.idsucursal }
      })
    ];

    forkJoin(observables).subscribe(
      (respuesta: any) => {
        this.spinner.hide();
        const optica = respuesta[0];
        const contactologia = respuesta[1];
        const atendidos = respuesta[2];

        this.turnosOpticaDB = optica[0].length == 0 ? [] : optica[0];
        this.turnosContactologiaDB = contactologia[0].length == 0 ? [] : contactologia[0];
        this.turnosAtendidosDB = atendidos[0].length == 0 ? [] : atendidos[0];
        this.verificarRecordatorioAtencion();
      },
      (err) => {
        console.error('[recordatorio] refrescar forkJoin ERROR (no verifica)', err);
      }
    );
  }

  private verificarRecordatorioAtencion(): void {
    if (!this.authService.userData || !this.authService.userData.id_puesto) {
      return;
    }

    if (this.cerrandoTurnoPorAviso) {
      return;
    }

    const idPuesto = this.authService.userData.id_puesto;
    const turnoAtendiendo = []
      .concat(this.turnosOpticaDB || [])
      .concat(this.turnosContactologiaDB || [])
      .find((t: any) => t.idEstado == 4 && t.idPuesto == idPuesto);

    if (!turnoAtendiendo) {
      if (this.showModalRecordatorio) {
        this.cerrarModalRecordatorio(false);
      }
      return;
    }

    const idTurno = turnoAtendiendo.idTurno;

    // Modal ya abierto: si pasó la gracia sin respuesta → finalizar turno
    if (this.showModalRecordatorio && this.avisoRecordatorioDesde != null) {
      const minutosAviso = (Date.now() - this.avisoRecordatorioDesde) / 60000;
      if (minutosAviso >= this.minutosRecordatorioAviso) {
        this.finalizarTurnoPorAvisoSinRespuesta(turnoAtendiendo);
        return;
      }
      this.turnoRecordatorio = turnoAtendiendo;
      return;
    }

    // GetTurnosPendientesBack no incluye fechaAtencion → cache / findById
    const fechaAtencion = turnoAtendiendo.fechaAtencion
      || turnoAtendiendo.FechaAtencion
      || this.fechasAtencionPorTurno[idTurno]
      || null;

    if (!fechaAtencion) {
      if (this.cargandoFechaAtencionId !== idTurno) {
        this.cargandoFechaAtencionId = idTurno;
        this.turnoApi.findById(idTurno).subscribe(
          (res: Turno) => {
            this.cargandoFechaAtencionId = null;
            if (res && res.fechaAtencion) {
              this.fechasAtencionPorTurno[idTurno] = res.fechaAtencion;
              this.verificarRecordatorioAtencion();
            }
          },
          () => {
            this.cargandoFechaAtencionId = null;
          }
        );
      }
      return;
    }

    if (this.recordatorioSnoozeIdTurno === idTurno && this.recordatorioSnoozeHasta != null) {
      if (Date.now() < this.recordatorioSnoozeHasta) {
        return;
      }
    }

    const inicio = new Date(fechaAtencion).getTime();
    // Misma convención -3h que usa el resto del componente al persistir fechas
    const ahoraAjustado = Date.now() - 3 * 60 * 60 * 1000;
    const minutosTranscurridos = (ahoraAjustado - inicio) / 60000;

    if (minutosTranscurridos >= this.minutosRecordatorio) {
      this.turnoRecordatorio = turnoAtendiendo;
      this.showModalRecordatorio = true;
      if (this.avisoRecordatorioDesde == null) {
        this.avisoRecordatorioDesde = Date.now();
      }
    }
  }

  private finalizarTurnoPorAvisoSinRespuesta(turno: any): void {
    this.cerrandoTurnoPorAviso = true;
    this.cerrarModalRecordatorio(true);
    this.toastr.warning('Turno finalizado automáticamente por falta de respuesta al aviso');
    this.cambiarEstado(3, turno);
    // El flag se limpia al completar el cambio de estado / próximo ciclo sin modal
    setTimeout(() => {
      this.cerrandoTurnoPorAviso = false;
    }, 2000);
  }

  seguirAtendiendoRecordatorio(): void {
    if (!this.turnoRecordatorio) {
      this.cerrarModalRecordatorio(false);
      return;
    }
    this.recordatorioSnoozeIdTurno = this.turnoRecordatorio.idTurno;
    this.recordatorioSnoozeHasta = Date.now() + this.minutosRecordatorio * 60 * 1000;
    this.cerrarModalRecordatorio(false);
    this.toastr.info('Recordatorio pospuesto ' + this.minutosRecordatorio + ' minutos');
  }

  finalizarDesdeRecordatorio(): void {
    const turno = this.turnoRecordatorio;
    this.cerrarModalRecordatorio(true);
    if (turno) {
      this.cambiarEstado(3, turno);
    }
  }

  private cerrarModalRecordatorio(limpiarSnooze: boolean): void {
    this.showModalRecordatorio = false;
    this.turnoRecordatorio = null;
    this.avisoRecordatorioDesde = null;
    if (limpiarSnooze) {
      this.recordatorioSnoozeHasta = null;
      this.recordatorioSnoozeIdTurno = null;
    }
  }

  textoTurnoRecordatorio(): string {
    if (!this.turnoRecordatorio) {
      return '';
    }
    const nro = this.turnoRecordatorio.numerador != null ? this.turnoRecordatorio.numerador : '';
    const apellido = this.turnoRecordatorio.apellido || '';
    const nombre = this.turnoRecordatorio.nombre || '';
    return ('N° ' + nro + ' — ' + apellido + ' ' + nombre).trim();
  }

  esReclamo(sector: string): boolean {
    return sector && sector.trim().toUpperCase() === 'RECLAMOS';
  }

  textoSector(sector: string): string {
    if (!sector) {
      return '';
    }
    const normalizado = sector.trim().toUpperCase();
    if (normalizado === 'OBRA SOCIAL' || normalizado === 'PAMI' || normalizado === 'PARTICULAR') {
      return 'RECETA';
    }
    return sector;
  }

  getTurnosLlamados() {
    this.turnoApi.find({
      order: 'horaLlamado DESC',
      where: {
        and: [
          { horaLlamado: { neq: null } },
          { horaEntrega: null },
          { fechaAnulacion: null }
        ]
      }
    }).subscribe((turnos: Array<Turno>) => {
      this.turnosLlamados = turnos;
    });
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/display-cliente-v2/display-cliente-v2.component.ts